import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@environments/environment';

export const discountCouponGuard: CanActivateFn = () => {
    if (!environment.showDiscountCoupon) {
        const router = inject(Router);
        router.navigate(['/']);
        return false;
    }
    return true;
};
